let searchIcon = document.querySelector('header button.search-btn');
let searchPage = document.querySelector('body.search');

if (searchIcon) {
    let search = document.querySelector('#search');
    let searchInput = document.querySelector('#search #search-input');
    searchIcon.addEventListener('click', function (e) {
        e.preventDefault();
        if(search.classList.contains('expand')) {
            searchIcon.classList.remove('open');
            search.classList.remove('set-width');
            setTimeout(function() {
                search.classList.remove('expand');
            }, 300);
        }
        else {
            searchIcon.classList.add('open');
            search.classList.add('expand');
            searchInput.focus();
            setTimeout(function() {
                search.classList.add('set-width');
            }, 10);
        }
    });
    window.addEventListener('click', function(e) {
        if (!e.target.closest('.search-wrapper') && document.querySelector('#search').classList.contains('expand')) {
            searchIcon.classList.remove('open');
            document.querySelector('#search').classList.remove('set-width');
            setTimeout(function() {
                document.querySelector('#search').classList.remove('expand');
            }, 300);
        }
      });
}

if (searchPage) {
    let pageSearchInput = searchPage.querySelector('#search-page #search-page-input');
    let inputValue = searchPage.querySelector('#content-section #search-page #search-page-input').value;
    pageSearchInput.focus();
    pageSearchInput.value = '';
    pageSearchInput.value = inputValue;
}
